// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1647":"d4b27f72459f222d","2519":"6a19532257a6a0e8","3548":"a7572c302d5f5fa8","4794":"315428e58bb26144","7483":"cc3c90e7376cb964","8429":"45162d66ed014f53","9032":"4b89a2c511fc9984"}[chunkId] + ".js";
};